import service from './request'

// 登录
export const login = (data) => {
    return service({
        url: '/login/login',
        method: 'post',
        data
    })
}
// 退出登录
export const logout = () => {
    return service({
        url: '/login/logout',
        method: 'get',
    })
}
// 获取验证码
export const imageCode = (code) => {
    return service({
        url: '/login/imageCode/' + code,
        method: 'get',
        // responseType: 'arraybuffer'
    })
}



// // 发送手机验证码
// export const getCode = (data='') => {
//     return service({
//         url:'/gdt-web/api/sendVerificationCode?phone='+data,
//         method:'get',
//     })
// }


// // 通过验证码登录
// export const verificationCodeLogin = (data={'phone':'','captcha':'','businessId':''}) => {
//     // data.businessId = "de02f94c09cb4913b65b6a4b83893a01"
//     return service({
//         url:'/gdt-web/login/textLogin',
//         method:'post',
//         data
//     })
// }

// 大屏数据
export const getBigScreenData = () => {
    return service({
        url: `/BigScreen/getData`,
        method: 'get',
    })
}
// 零碳活动/零碳出行
export const getActivity = (data, page) => {
    return service({
        url: `/csrmp-travel-activity/getListByPage?current=${page.current}&size=${page.size}`,
        method: 'post',
        data
    })
}

export const getTravelList = (data, page) => {
    return service({
        url: `/travel-info/getListByPage?current=${page.current}&size=${page.size}`,
        method: 'post',
        data
    })
}

export const handleCheckOne = id => {
    return service({
        url: `/csrmp-travel-activity/firstLevelAudit?id=${id}`,
        method: 'get'
    })
}
// 二级审核
export const handleCheckTwo = id => {
    return service({
        url: `/csrmp-travel-activity/twoLevelAudit?id=${id}`,
        method: 'get'
    })
}

// 碳排贡献量列表
export const getCarbonEmissionList = (data, page) => {
    return service({
        url: `/carbon-emission/getListByPage?current=${page.current}&size=${page.size}`,
        method: 'post',
        data
    })
}
// 碳排贡献量新增或修改
export const carbonEmissionSubmit = data => {
    return service({
        url: '/carbon-emission/saveOrUpdate',
        method: 'post',
        data
    })
}
// 碳排贡献量详情
export const getCarbonEmissionDetail = id => {
    return service({
        url: `/carbon-emission/detailById/${id}`,
        method: 'get'
    })
}
// 碳排贡献量根据ID删除
export const delCarbonEmissionInfo = id => {
    return service({
        url: `/carbon-emission/removeById?id=${id}`,
        method: 'get',
    })
}

// 碳吸收贡献量列表
export const getCarbonUptakeList = (data, page) => {
    return service({
        url: `/carbon-uptake/getListByPage?current=${page.current}&size=${page.size}`,
        method: 'post',
        data
    })
}
// 碳吸收贡献量新增或修改
export const carbonUptakeSubmit = data => {
    return service({
        url: '/carbon-uptake/saveOrUpdate',
        method: 'post',
        data
    })
}
// 碳吸收贡献量详情
export const getCarbonUptakeDetail = id => {
    return service({
        url: `/carbon-uptake/detailById/${id}`,
        method: 'get'
    })
}
// 碳吸收贡献量根据ID删除
export const delCarbonUptakeInfo = id => {
    return service({
        url: `/carbon-uptake/removeById?id=${id}`,
        method: 'get',
    })
}

// 碳排贡献量列表
export const getCarbonEmissionReductionsList = (data, page) => {
    return service({
        url: `/carbon-emission-reductions/getListByPage?current=${page.current}&size=${page.size}`,
        method: 'post',
        data
    })
}
// 碳减排贡献量单条新增或修改
export const carbonEmissionReductionsSubmit = data => {
    return service({
        url: '/carbon-emission-reductions/saveOrUpdate',
        method: 'post',
        data
    })
}
// 碳减排贡献量详情
export const getCarbonEmissionReductionsDetail = id => {
    return service({
        url: `/carbon-emission-reductions/detailById/${id}`,
        method: 'get'
    })
}
// 碳减排贡献量根据ID删除
export const delCarbonEmissionReductionsInfo = id => {
    return service({
        url: `/carbon-emission-reductions/removeById?id=${id}`,
        method: 'get',
    })
}

// 各行业碳排数据列表
export const getIndustryCarbonEmissionsList = (data, page) => {
    return service({
        url: `/industry-carbon-emissions/getListByPage?current=${page.current}&size=${page.size}`,
        method: 'post',
        data
    })
}
// 各行业碳排数据单条新增或修改
export const industryCarbonEmissionsSubmit = data => {
    return service({
        url: '/industry-carbon-emissions/saveOrUpdate',
        method: 'post',
        data
    })
}

// 各行业碳排数据详情
export const getIndustryCarbonEmissionsDetail = id => {
    return service({
        url: `/industry-carbon-emissions/detailById/${id}`,
        method: 'get'
    })
}
// 各行业碳排数据根据ID删除
export const delIndustryCarbonEmissionsInfo = id => {
    return service({
        url: `/industry-carbon-emissions/removeById?id=${id}`,
        method: 'get',
    })
}

// 历年碳排数据列表
export const getCarbonEmissionsOverTimeList = (data, page) => {
    return service({
        url: `/carbon-emissions-over-time/getListByPage?current=${page.current}&size=${page.size}`,
        method: 'post',
        data
    })
}
//  历年碳排数据单条新增或修改
export const carbonEmissionsOverTimeSubmit = data => {
    return service({
        url: '/carbon-emissions-over-time/saveOrUpdate',
        method: 'post',
        data
    })
}
//  历年碳排数据详情
export const getCarbonEmissionsOverTimeDetail = id => {
    return service({
        url: `/carbon-emissions-over-time/detailById/${id}`,
        method: 'get'
    })
}
//  历年碳排数据根据ID删除
export const delCarbonEmissionsOverTimeInfo = id => {
    return service({
        url: `/carbon-emissions-over-time/removeById?id=${id}`,
        method: 'get',
    })
}

// 年度碳排数据列表
export const getAnnualCarbonEmissionsList = (data, page) => {
    return service({
        url: `/annual-carbon-emissions/getListByPage?current=${page.current}&size=${page.size}`,
        method: 'post',
        data
    })
}
//  年度碳排数据单条新增或修改
export const annualCarbonEmissionsSubmit = data => {
    return service({
        url: '/annual-carbon-emissions/saveOrUpdate',
        method: 'post',
        data
    })
}
//  年度碳排数据详情
export const getAnnualCarbonEmissionsDetail = id => {
    return service({
        url: `/annual-carbon-emissions/detailById/${id}`,
        method: 'get'
    })
}
//  年度碳排数据根据ID删除
export const delAnnualCarbonEmissionsInfo = id => {
    return service({
        url: `/annual-carbon-emissions/removeById?id=${id}`,
        method: 'get',
    })
}


// 政策信息列表
export const getPolicyInfoList = (data, page) => {
    return service({
        url: `/policy-info/getListByPage?current=${page.current}&size=${page.size}`,
        method: 'post',
        data
    })
}
// 政策信息表详情
export const getPolicyDetail = id => {
    return service({
        url: '/policy-info/detailById/' + id,
        method: 'get'
    })
}
// 政策信息新增或修改
export const policyInfoSubmit = data => {
    return service({
        url: '/policy-info/saveOrUpdate',
        method: 'post',
        data
    })
}
// 政策信息表根据ID删除
export const delPolicyInfo = id => {
    return service({
        url: `/policy-info/removeById?id=${id}`,
        method: 'get',
    })
}
// 文件上传
export const fileUpload = (data) => {
    return service({
        url: `/file/upload`,
        method: 'post',
        data
    })
}
// 删除文件
export const removeFileById = (id) => {
    return service({
        url: `/file/removeById?id=${id}`,
        method: 'post',
    })
}

// 用户列表
export const getCarbonSinkUserList = (data, page) => {
    return service({
        url: `/user/selectPage?current=${page.current}&size=${page.size}`,
        method: 'post',
        data
    })
}

// 新增用户
export const addCarbonSinkUser = (data) => {
    return service({
        url: `/user/addUser`,
        method: 'post',
        data
    })
}

// 删除用户
export const delCarbonSinkUse = (id) => {
    return service({
        url: `/user/del/${id}`,
        method: 'get',
    })
}

// 修改用户
export const updateCarbonSinkUser = (data) => {
    return service({
        url: `/user/updUser`,
        method: 'post',
        data
    })
}

// 重置密码(参数只传ID and password)
export const carbonSinkResetPassword = (data) => {
    return service({
        url: `/user/resetPassword`,
        method: 'post',
        data
    })
}

// 零碳课堂
export const getClassroomList = (data, page) => {
    return service({
        url: `/zero-carbon-classroom/getListByPage?current=${page.current}&size=${page.size}`,
        method: 'post',
        data
    })
}

// 分页获取零碳课堂明细
export const getZeroCarbonClassroomDetailPageList = (data, page) => {
    return service({
        url: `/zero-carbon-classroom-detail/getZeroCarbonClassroomDetailPageList?current=${page.current}&size=${page.size}`,
        method: 'post',
        data
    })
}
// 新增用户
export const insertZeroDetail = (data) => {
    return service({
        url: `/zero-carbon-classroom-detail/insertZeroDetail`,
        method: 'post',
        data
    })
}

// 删除用户
export const removeZeroDetail = (id) => {
    return service({
        url: `/zero-carbon-classroom-detail/removeZeroDetail?id=${id}`,
        method: 'get',
    })
}

// 修改用户
export const updateZeroDetail = (data) => {
    return service({
        url: `/zero-carbon-classroom-detail/updateZeroDetail`,
        method: 'post',
        data
    })
}

// 零碳公司日条件分页查询
export const getListByPage = (data, page) => {
    return service({
        url: `/new-csrmp-zero-carbon-classroom/getListByPage?current=${page.current}&size=${page.size}`,
        method: 'post',
        data
    })
}

// 修改用户
export const downloadExcel = (data) => {
    return service({
        url: `/new-csrmp-zero-carbon-classroom/downloadExcel`,
        method: 'post',
        data,
        responseType: "blob",
    })
}

// 碳标签分页查询
export const getCarbonlabelList = (data, page) => {
    return service({
        url: `/carbon-label/getListByPage?current=${page.current}&size=${page.size}`,
        method: 'post',
        data
    })
}

// 碳标签新增
export const carbonlabelSave = data => {
    return service({
        url: '/carbon-label/save',
        method: 'post',
        data
    })
}
// 碳标签编辑
export const carbonlabelEdit = data => {
    return service({
        url: '/carbon-label/update',
        method: 'post',
        data
    })
}
// 碳标签根据ID删除
export const delCarbonlabel = id => {
    return service({
        url: `/carbon-label/removeById?id=${id}`,
        method: 'get',
    })
}
// 零碳活动/导出
export const activityExport = (data) => {
    return service({
        url: `/csrmp-travel-activity/activityExport`,
        method: 'post',
        data,
        // excel 文档转码
        responseType: 'blob'
    })
}
// 零碳出行/导出
export const travelExport = (data) => {
    return service({
        url: `/travel-info/travelExport`,
        method: 'post',
        data,
        responseType: 'blob'
    })
}
// 零碳植树列表
export const getTreeList = (data,page) => {
  return service({
      url: `/treePlantingRecords/queryPageList?current=${page.current}&size=${page.size}`,
      method: 'post',
      data
  })
}
// 零碳植树批量上传
export const treeSave = data => {
  return service({
      url: '/treePlantingRecords/batchUpdateRecord',
      method: 'post',
      data
  })
}
// 零碳植树编辑
export const treeEdit = data => {
  return service({
      url: '/treePlantingRecords/updateRecord',
      method: 'post',
      data
  })
}
// 零碳植树导出
export const treeExport = (data) => {
  return service({
      url: `/treePlantingRecords/exportTreePlantingRecord`,
      method: 'post',
      data,
      // excel 文档转码
      responseType: 'blob'
  })
}

// 碳汇+N
export const carbonList = (data) => {
  return service({
      url: `/zeroCarbonRecord/queryPageList`,
      method: 'post',
      data,
  })
}

// 碳汇+N
export const carbonDetail = (data) => {
  return service({
      url: `/zeroCarbonRecord/getZeroCarbonRecordDetail?id=${data}`,
      method: 'post',
  })
}

// 零碳植树导出
export const carbonExport = (data) => {
  return service({
      url: `/zeroCarbonRecord/exportZeroCarbonRecord`,
      method: 'post',
      data,
      // excel 文档转码
      responseType: 'blob'
  })
}

// 碳汇+N
export const carbonAudit = (data) => {
  return service({
      url: `/zeroCarbonRecord/checkRecord?id=${data}`,
      method: 'post',
  })
}

// 碳汇+N
export const markVlaueAudit = (data) => {
  return service({
      url: `/zeroCarbonRecord/submitRemark`,
      method: 'post',
      data
  })
}

